import './polyfills';
import 'bootstrap/dist/css/bootstrap.min.css';
console.log('Build timestamp:', new Date().toISOString());
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
// import * as serviceWorker from './serviceWorker';
import { Provider } from 'react-redux';
import thunk from 'redux-thunk';
import { createStore, applyMiddleware, compose } from 'redux';
import reducers from './reducers';
import { MsalProvider } from "./msal-context";
import { msalConfig, loginRequest } from "./auth-config";
import { PersistGate } from 'redux-persist/integration/react'
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage' 
//import swDev from './swDev'
import './i18n'; // Import i18n configuration

const persistConfig = {
  key: 'root',
  storage,
}
 
const persistedReducer = persistReducer(persistConfig, reducers)

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(persistedReducer, composeEnhancers(applyMiddleware(thunk)));
let persistor = persistStore(store)
ReactDOM.render(
  <MsalProvider
    config={msalConfig}
    scopes={loginRequest}
  >
    <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
        <App />
        </PersistGate>
    </Provider>
    </MsalProvider>,
    document.getElementById('root'));

//swDev();
